const hashKey = (path, args) => `${path}:${JSON.stringify(args)}`;

export default new class {
  lock(method, path, args) {
    if (undefined === this[method]) {
      this[method] = Object.create(null);
    }
    this[method][hashKey(path, args)] = true;
  }

  isLocked(method, path, args) {
    if (undefined === this[method]) {
      return false;
    }
    return undefined !== this[method][hashKey(path, args)];
  }

  unlock(method, path, args) {
    if (undefined !== this[method] && undefined !== this[method][hashKey(path, args)]) {
      delete this[method][hashKey(path, args)];
    }
  }
};